import * as ko from "knockout";
import { TalkAboutHtml } from "./lib/TalkAboutHtml"
import TalkAboutSummernoteFactory from "./talkabout-summernote-factory";


declare global {
    interface Window { thisPage: any; __localeId__: String; }
}
declare var $;
declare var modalManager;
declare var windowHelper;
declare var captchaHelper;

(() => {
    document.addEventListener("DOMContentLoaded", async function () {

        let summernoteFactory= new TalkAboutSummernoteFactory();

        ko.extenders.required = function (target, overrideMessage) {
            target.hasError = ko.observable();
            target.validationMessage = ko.observable();
            function validate(newValue) {
                target.hasError(newValue ? false : true);
                target.validationMessage(newValue ? "" : overrideMessage || "This field is required");
            }
            validate(target());
            target.subscribe(validate);
            return target;
        };
        ko.options.useOnlyNativeEvents = true;              

        //custom KnockOut binding
        ko.bindingHandlers.richText = {           
            init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
                let editor: any = null;
                let modelValue = valueAccessor();
                let value = ko.utils.unwrapObservable(valueAccessor());
                // @ts-ignore
                let element$ = $(element);
                let talkAboutModel = viewModel as TalkAboutHtml;

                // Set initial value and create the CKEditor
                element$.html(value);             
                editor = summernoteFactory.getEditor(element$[0].id);
                
                editor.on('summernote.change', function (we, contents, $editable) {                       
                    var observable = valueAccessor();
                    observable(editor.summernote('code'));                    
                });                        
                             
                /* Handle disposal if KO removes an editor 
                 * through template binding */
                //ko.utils.domNodeDisposal.addDisposeCallback(element,
                //    function () {
                //        editor.updateElement();
                //        editor.destroy();
                //    });
            },

            update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {             
                let value = valueAccessor();
                let editor = summernoteFactory.getEditor(element.id);
                let newValue = ko.utils.unwrapObservable(valueAccessor());               

                if (editor.summernote('code') != newValue) {
                    editor.summernote('code', newValue);                   
                }   
            }
        }


        let threadElements = document.querySelectorAll('[data-talkabout-project-id]');
        if (threadElements && threadElements.length > 0) {
            for (let i = 0; i < threadElements.length; i++) { 
                if (i === 0) {
                    //setup summernote config object
                    await summernoteFactory.InitConfig(threadElements[i] as HTMLDivElement);                   
                }                
                let viewModel = new TalkAboutHtml(threadElements[i] as HTMLDivElement, summernoteFactory);

                //add a delay so other components like maps can load first
                setTimeout(() => {
                    ko.applyBindings(viewModel);
                }, 500);
                
            }
        }

        
    });
})();



